/**
 * Lightweight GA4 wrapper. Safe to call from anywhere – no-op when
 * gtag is not loaded (uporabnik še ni dal soglasja ali ID ni nastavljen).
 */
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

export function trackEvent(name: string, params: Record<string, unknown> = {}) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag === "function") {
    try {
      window.gtag("event", name, params);
    } catch {
      // ignore
    }
  }
}

export const CONSENT_STORAGE_KEY = "cookie_consent_v1";
export const CONSENT_EVENT = "cookie-consent-changed";
export type ConsentValue = "accepted" | "essential" | null;

export function readConsent(): ConsentValue {
  if (typeof window === "undefined") return null;
  try {
    const v = window.localStorage.getItem(CONSENT_STORAGE_KEY);
    if (v === "accepted" || v === "essential") return v;
    return null;
  } catch {
    return null;
  }
}

export function setConsent(value: "accepted" | "essential") {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(CONSENT_STORAGE_KEY, value);
    window.dispatchEvent(new CustomEvent(CONSENT_EVENT, { detail: value }));
  } catch {
    // ignore
  }
}